/** The Documents page's tabs. All three work in both view modes; in Building
 * view, Folders first asks which project's folders to open. */
export type DocViewMode = "folders" | "timeline" | "list";

export const DOC_VIEW_MODE_STORAGE_KEY = "documents-viewMode";

/** The stored tab preference, or null when absent/invalid. */
export function loadStoredDocViewMode(): DocViewMode | null {
  const stored = localStorage.getItem(DOC_VIEW_MODE_STORAGE_KEY);
  return stored === "folders" || stored === "list" || stored === "timeline" ? stored : null;
}

/**
 * Clamp the stored tab preference to what the current role offers.
 * Render-derived and never written back to storage. Without a stored choice
 * both view modes open on Folders.
 */
export function resolveDocViewMode(
  stored: DocViewMode | null,
  available: DocViewMode[]
): DocViewMode {
  if (stored && available.includes(stored)) return stored;
  const preferred: DocViewMode = "folders";
  if (available.includes(preferred)) return preferred;
  return available[0] ?? "timeline";
}
